import { Component } from "react";
import { isDiagnosticsEnabled } from "../../../utils/diagnostics";

export default class DiagnosticsGuard extends Component {
  render() {
    return isDiagnosticsEnabled() ? this.props.children : null;
  }
}
